/* [BD] Ingredients / studies tabs — bd-ingredients.liquid */
;(function () {
  function initBdStudies(root) {
    if (!root) return;

    var triggers = root.querySelectorAll('[data-bd-studies-tab-target]');
    var panels = root.querySelectorAll('[data-bd-studies-panel]');

    if (!triggers.length || !panels.length) return;

    var background = root.querySelector('.bd-studies__background');
    var defaultBg = background ? background.getAttribute('data-bd-studies-bg-default') : '';
    var defaultBgColor = background
      ? background.getAttribute('data-bd-studies-bg-color-default')
      : '';

    function updateBackgroundFromTrigger(triggerEl) {
      if (!background || !triggerEl) return;

      var tabBg = triggerEl.getAttribute('data-bd-studies-bg');
      var tabBgColor = triggerEl.getAttribute('data-bd-studies-bg-color');

      var imageUrl = tabBg && tabBg !== '' ? tabBg : defaultBg;
      if (imageUrl && imageUrl !== '') {
        background.style.backgroundImage = 'url(' + imageUrl + ')';
      } else {
        background.style.removeProperty('background-image');
      }

      var colorValue = tabBgColor && tabBgColor !== '' ? tabBgColor : defaultBgColor;
      if (colorValue && colorValue !== '') {
        background.style.backgroundColor = colorValue;
      } else {
        background.style.removeProperty('background-color');
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetId = trigger.getAttribute('data-bd-studies-tab-target');

        triggers.forEach(function (t) {
          var isActive = t === trigger;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.toggle(
            'is-active',
            panel.getAttribute('data-bd-studies-panel') === targetId
          );
        });

        updateBackgroundFromTrigger(trigger);
      });
    });

    var initialActive = root.querySelector('.bd-studies__tab-trigger.is-active');
    if (initialActive) {
      updateBackgroundFromTrigger(initialActive);
    }
  }

  function boot(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.bd-studies').forEach(initBdStudies);
    if (root.matches && root.matches('.bd-studies')) {
      initBdStudies(root);
    }
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdSectionStudiesIngredientsDesignMode) {
    window.__bdSectionStudiesIngredientsDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
  }
})();
